export const getSelf = (loc = 'ybApi', config = {}) => ({
  endpoint: '/users/self',
  loc,
  ...config,
});

export const getWorkspaceMemberProfile = (workspaceId, loc = 'ybApi', config = {}) => ({
  endpoint: `/organisations/${workspaceId}/members/self/profile`,
  loc,
  ...config,
});

export const getWorkspaceDetail = (workspaceId, loc = 'ybApi', config = {}) => ({
  endpoint: `/organisations/${workspaceId}`,
  resourceAction: 'READ_RESOURCES',
  requestKey: `READ_WORKSPACE_DETAIL_${workspaceId}`,
  resourceType: 'workspaceDetail',
  resources: [workspaceId],
  loc,
  ...config,
});

export const getWorkspaceMemberList = (workspaceId, loc = 'ybApi', config = {}) => ({
  endpoint: `/organisations/${workspaceId}/members`,
  resourceAction: 'READ_RESOURCES',
  requestKey: `READ_WORKSPACE_MEMBER_LIST_${workspaceId}`,
  resourceType: 'workspaceMemberList',
  apiResource: 'members',
  loc,
  ...config,
});


export const getTemplateList = (workspaceId, loc = 'ybApi', config = {}) => ({
  endpoint: `/organisations/${workspaceId}/cmrs`,
  requestKey: 'GET_TEMPLATE_LIST',
  resourceType: 'templateList',
  apiResource: 'cmrs',
  resourceAction: 'READ_RESOURCES',
  loc,
  ...config,
});

export const getWorkspaceList = (userId, loc = 'ybApi', config = {}) => ({
  endpoint: `/users/${userId}/organisations`,
  requestKey: 'GET_WORKSPACE_LIST',
  resourceType: 'workspaceList',
  apiResource: 'organisations',
  resourceAction: 'READ_RESOURCES',
  loc,
  ...config,
});

export const postCampaign = (workspaceId, data = {}, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/campaigns`,
  method: 'POST',
  resourceType: 'campaignDetail',
  requestKey: 'POST_CAMPAIGN',
  resourceAction: 'CREATE_RESOURCES',
  apiResource: 'id',
  cachePolicy: 'network-only',
  data,
  loc,
});

export const postCampaignUpdate = (workspaceId, campaignId, data = {}, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/campaigns/${campaignId}`,
  method: 'POST',
  resourceType: 'campaignDetail',
  requestKey: `POST_CAMPAIGN_UPDATE_${campaignId}`,
  resourceAction: 'UPDATE_RESOURCES',
  apiResource: 'id',
  cachePolicy: 'network-only',
  resources: [{ id: campaignId, ...data }],
  data,
  loc,
});

export const postCampaignReportRequest = (organisationId, campaignId, data = {}, loc = 'ybApi') => ({
  endpoint: `/organisations/${organisationId}/campaigns/${campaignId}/reports`,
  method: 'POST',
  data,
  requestKey: `REQUEST_CAMPAIGN_REPORT_${campaignId}`,
  loc,
});

export const postSurvey = (workspaceId, data = {}, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/surveys`,
  method: 'POST',
  resourceType: 'surveyDetail',
  requestKey: 'POST_SURVEY',
  resourceAction: 'CREATE_RESOURCES',
  apiResource: 'id',
  cachePolicy: 'network-only',
  data,
  loc,
});

export const postSurveyUpdate = (workspaceId, surveyId, data = {}, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/surveys/${surveyId}`,
  method: 'POST',
  resourceType: 'surveyDetail',
  requestKey: `POST_SURVEY_UPDATE_${surveyId}`,
  resourceAction: 'UPDATE_RESOURCES',
  apiResource: 'id',
  cachePolicy: 'network-only',
  resources: [{ id: surveyId, ...data }],
  data,
  loc,
});

export const getCampaignList = (workspaceId, queries = '', loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/campaigns?${queries}`,
  method: 'GET',
  resourceType: 'campaignList',
  requestKey: 'GET_CAMPAIGN_LIST',
  resourceAction: 'READ_RESOURCES',
  apiResource: 'campaigns',
  loc,
});

export const getCampaign = (workspaceId, campaignId, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/campaigns/${campaignId}`,
  method: 'GET',
  resourceType: 'campaignDetail',
  requestKey: `GET_CAMPAIGN_${campaignId}`,
  resourceAction: 'READ_RESOURCES',
  loc,
});

export const getSurveyList = (workspaceId, queries = '', loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/surveys?${queries}`,
  method: 'GET',
  resourceType: 'surveyList',
  requestKey: 'GET_SURVEY_LIST',
  resourceAction: 'READ_RESOURCES',
  apiResource: 'surveys',
  loc,
});

export const getSurvey = (workspaceId, surveyId, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/surveys/${surveyId}`,
  method: 'GET',
  resourceType: 'surveyDetail',
  requestKey: `GET_SURVEY_${surveyId}`,
  resourceAction: 'READ_RESOURCES',
  apiResource: 'survey',
  loc,
});

export const getSurveyResults = (workspaceId, surveyId, resultType = 'results', loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/surveys/${surveyId}/${resultType}`,
  method: 'GET',
  resourceType: 'surveyResponses',
  requestKey: `GET_SURVEY_RESPONSES_${surveyId}`,
  resourceAction: 'READ_RESOURCES',
  cachePolicy: 'cache-and-network',
  apiResource: 'results',
  loc,
});

export const postFileLocation = (workspaceId, type, data = {}, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/files/${type}`,
  method: 'POST',
  requestKey: 'POST_FILE_LOCATION',
  data,
  loc,
});

export const getFile = (workspaceId, id, config = {}, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/files/${id}`,
  method: 'GET',
  resourceType: 'fileDetail',
  apiResource: 'file',
  requestKey: `GET_FILE_${id}`,
  resourceAction: 'READ_RESOURCES',
  ...config,
  loc,
});

export const getAvailableMsns = (capabilities = '', loc = 'ybApi') => ({
  endpoint: `/msns?capabilities=voice,${capabilities}&unassigned`,
  method: 'GET',
  requestKey: 'GET_AVAILABLE_MSNS',
  loc,
});

export const postMsn = (workspaceId, msn, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/msns/${msn}`,
  method: 'PUT',
  data: {},
  requestKey: 'PUT_ORGANISATION_MSN',
  loc,
});

export const postMsnUpdate = (workspaceId, msn, type, data, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/msns/${msn}/${type}`,
  method: 'POST',
  data,
  requestKey: 'POST_ORGANISATION_MSN_CONFIG',
  loc,
});

export const postMsnOptions = (workspaceId, msn, data, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/msns/${msn}`,
  method: 'POST',
  data,
  requestKey: 'POST_ORGANISATION_MSN_OPTIONS',
  loc,
});

export const getMsns = (workspaceId, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/msns`,
  method: 'GET',
  requestKey: 'GET_MSNS',
  loc,
});

export const getMsn = (workspaceId, msn, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/msns/${msn}`,
  method: 'GET',
  resourceType: 'msnDetail',
  requestKey: `GET_MSN_${msn}`,
  resourceAction: 'READ_RESOURCES',
  resourceId: msn,
  loc,
});

export const postListItems = (workspaceId, listId, data, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/lists/${listId}/items`,
  method: 'POST',
  requestKey: 'POST_LIST_ITEMS',
  data,
  loc,
});

export const postList = (workspaceId, data, loc = 'ybApi') => ({
  endpoint: `/organisations/${workspaceId}/lists`,
  method: 'POST',
  data,
  requestKey: 'CREATE_LIST',
  resourceType: 'lists',
  apiResource: 'id',
  resources: [data],
  resourceAction: 'CREATE_RESOURCES',
  cachePolicy: 'network-only',
  loc,
});